import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';

import TogetherProductpopup from './TogetherProductpopup';
import Togetherlinepopup from './Togetherlinepopup';
import Pricepopup from './Pricepopup';

import {
  isMobile
} from "react-device-detect";

export default class Togetherpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            product_index: 0,
            select_line_product: null,
            select_focus_line_index: -1,
            select_year_index: 0,
            uselines: 1,
            line_discount: 0,
            lines: []
        };
        this.product_names = ["미적용","온가족플랜","온가족프리","한가족할인","온가족할인"];
        this.maxIndex = 5;
        this.selectIndex = 0;
        this.defaultLine = [ {
            name: "회선1",
            discount: 0,
            fee: null,
            obj: null,
            minus: 0
        },
        {
            name: "회선2",
            discount: 0,
            fee: null,
            obj: null,
            minus: 0
        },
        {
            name: "회선3",
            discount: 0,
            fee: null,
            obj: null,
            minus: 0
        },
        {
            name: "회선4",
            discount: 0,
            fee: null,
            obj: null,
            minus: 0
        },
        {
            name: "회선5",
            discount: 0,
            fee: null,
            obj: null,
            minus: 0
        }];
        this.warfareFee = 0;
        this.isOpened = false;
    }
    //
    passPriceItem(price_item)
    {
      let lines = this.defaultLine;
      this.defaultLine[0] = {
        name: "회선1",
        discount: 0,
        fee: price_item.name,
        obj: price_item,
        minus: 0
      };
      this.setState({
          lines: lines
      });
    }
    Open(price_item, _warfareFee)
    {
        this.setState({
            open: true
        });
        this.warfareFee = _warfareFee;
    }
    Close()
    {
        this.setState({
            open: false
        });
        this.isOpened = false;
    }
    OpenProductPopup()
    {
        let isThirdOk = false;
        if( this.state.lines[0].obj.price > 62000 ){
            isThirdOk = true;
        }
        this._togegherProductPopup.Open(isThirdOk);
    }
    OpenLinePopup()
    {
        this._togetherlinePopup.Open(this.state.product_index);
    }
    init(all)
    {
        let lines = this.defaultLine;

        lines[1].fee = null;
        lines[1].obj = null;
        lines[1].discount = 0;
        lines[1].minus = 0;

        lines[2].fee = null;
        lines[2].obj = null;
        lines[2].discount = 0;
        lines[2].minus = 0;

        lines[3].fee = null;
        lines[3].obj = null;
        lines[3].discount = 0;
        lines[3].minus = 0;

        lines[4].fee = null;
        lines[4].obj = null;
        lines[4].discount = 0;
        lines[4].minus = 0;
        if( all )
        {
          this.setState({
              product_index :0,
              select_line_product: null,
              select_focus_line_index: -1,
              line_discount: 0,
              lines: lines
          });
        } else {
          this.setState({
              select_line_product: null,
              select_focus_line_index: -1,
              line_discount: 0,
              lines: lines
          });
        }
    }
    onProductChanged(index)
    {
        // 상품이 바뀌면 다시 초기화 해줘야한다.
        if( this.state.product_index != index )
        {
            this.init();
        }
        if ( index == 4 ){
          this.setState({
            select_line_product : {
                idx: 0,
                name: "미적용",
                price: 0,
                internet_discount: 0,
                discounts: [0]
            },
              product_index: index
          }, this.recalc);
        } else {
          this.setState({
              product_index: index
          });
        }
    }
    onLineChanged(product)
    {
        if( this.state.product_index == 1 )
        {
            if( product && product.idx == 1 ){
                this.maxIndex = 2;
            }

            if( product && product.idx == 2 ) {
                this.maxIndex = 3;
            }

            if( product && product.idx == 3 ) {
                this.maxIndex = 4;
            }
        }
        this.setState({
            select_line_product: product
        }, this.recalc);
    }
    onPriceChanged(price)
    {
        if( this.selectIndex == 0 )
        {
          return ;
        }
        let lines = this.state.lines, uselines = 0;

        lines[this.selectIndex].fee = price.name;
        lines[this.selectIndex].obj = price;

        for( let i = 0 ; i < lines.length ; i++)
        {
            if( lines[this.selectIndex].obj )
            {
                uselines++;
            }
        }

        this.setState({
            lines: lines,
            uselines: uselines
        }, this.recalc);

        this._pricePopup.Close();
    }
    pricePopupOpen(index)
    {
        this.selectIndex = index;
        this._pricePopup.Open(true);
    }
    zeroLineminus(price)
    {
      this.state.lines[0].minus = price;
    }

    recalc()
    {
        let lines = this.state.lines, set_lines, select_line_product_idx = (this.state.select_line_product) ? this.state.select_line_product.idx : 0, max_fee;
        let line_discount = 0;
        const SMART_MAX = 14300;
        const SMART_ONE = 5500;
        const JUST_ONE  = 3300;
        if(this.state.product_index == 1)
        {
            let check = 0, isMAX = false;
            for( let i = 0 ; i < lines.length ; i++ )
            {
                if( lines[i].fee != null )
                {
                    check++;
                    if( lines[i].obj.price > 65890 )
                    {
                        isMAX = true;
                    }
                }
            }
            // 두개 이상, 100M 상품
            if( check > 1 && select_line_product_idx == 1 )
            {
                line_discount = 5610;
                if( check == 2 && isMAX )
                {
                    set_lines = this.recalcIndividual(SMART_MAX, check);
                    max_fee = SMART_MAX;
                } else if ( check == 2 ) {
                    set_lines = this.recalcIndividual(SMART_ONE, check);
                    max_fee = SMART_ONE;
                } else if ( check == 3 || check == 4 ) {
                    set_lines = this.recalcIndividual(SMART_ONE * 3, 3);
                    max_fee = SMART_ONE * 3;
                }
            }

            if( check > 1 && select_line_product_idx == 2 )
            {
                line_discount = 11110;
                set_lines = this.recalcIndividual(SMART_ONE * check, check);
                max_fee = SMART_ONE * check;
            }

            if( check > 1 && select_line_product_idx == 3 )
            {
                line_discount = 13310;
                set_lines = this.recalcIndividual(SMART_ONE * check, check);
                max_fee = SMART_ONE * check;
            }

            if(!max_fee)
            {
                max_fee = 0 ;
            }

            if( this.state.select_focus_line_index != -1 )
            {
                set_lines = this.recalcIndividual(max_fee, 1, true, this.state.select_focus_line_index);
            }

        } else if (this.state.product_index == 2) {
            let check = 0;
            for( let i = 0 ; i < lines.length ; i++ )
            {
                if( lines[i].fee != null )
                {
                    check++;
                }
            }
            set_lines = this.recalcIndividual(JUST_ONE, 1, true, 0);
            if( select_line_product_idx == 1)
            {
                line_discount = 3300;
            } else if (select_line_product_idx == 2 || select_line_product_idx == 3 ){
                line_discount = 7700;
            }
            line_discount = line_discount + ((check - 1) * 1100);
        } else if (this.state.product_index == 3) {
            line_discount = 8800;
        } else if (this.state.product_index == 4) {
            let line_discount_percent = [0.10,0.20,0.30,0.50];
            let line2_discount_percent = [0,0,0.10,0.30];
            if( this.state.select_line_product )
            {
              line_discount = this.state.select_line_product.price * line_discount_percent[this.state.select_year_index];
            }
            set_lines = this.state.lines;
            for ( let i = 0 ; i < set_lines.length ; i++ )
            {
                let l = set_lines[i];
                if( l.obj)
                {
                    let tabName = l.obj.tabname;
                    if( tabName.indexOf("T플랜") || tabName.indexOf("band") )
                    {
                        // 이거 두개면 아래 퍼센티지를 적용하고 확인시 Detail에 넘겨야한다.
                        l.discount = (l.obj.price) * line2_discount_percent[this.state.select_year_index];
                        if( i == 0 )
                        {
                          l.discount = (l.obj.price - l.minus) * line2_discount_percent[this.state.select_year_index];
                        }
                    } else {
                        l.discount = l.obj.price * line_discount_percent[this.state.select_year_index];
                    }
                }

            }
        }
        if(!set_lines)
        {
            set_lines = lines;
        }
        this.setState({
            line_discount: line_discount,
            lines: set_lines
        });
    }

    recalcIndividual(discountAll, divide, oneLine, index)
    {
        let lines = this.state.lines;
        if(!oneLine) {
            for( let i = 0 ; i < lines.length ; i++)
            {
                if(lines[i].fee != null && divide)
                {
                    lines[i].discount = discountAll / divide;
                }
            }
        } else {
            //나머지는 다 초기화
            for( let i = 0 ; i < lines.length ; i++)
            {
                if(lines[i].fee != null)
                {
                    lines[i].discount = 0;
                }
            }
            lines[index].discount = discountAll;
        }
        //console.log(lines);
        return lines;
    }

    onFocusLineChanged(event)
    {
        let value = event.target.value;
        this.setState({
            select_focus_line_index: value
        }, this.recalc);
    }

    onYearChanged(event)
    {
        let value = event.target.value;
        this.setState({
            select_year_index: value
        }, this.recalc)
    }

    hiddenApply()
    {
      if( this.state.select_line_product )
      {
        this.recalc();
        this.Apply();
      }

    }

    Apply()
    {
        const self = this;
        this.props.onTogetherChanged(
            self.product_names[self.state.product_index],
            self.state.select_line_product.name,
            self.state.lines,
            self.state.select_year_index,
            self.state.select_focus_line_index
        );
        self.Close();
    }

    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-md mb0 min300">
                    <div className={(isMobile) ? 'popupPadding3' : 'popupPadding pr45' }>
                        <div className="md-popup-header"> &nbsp;유무선 결합 설정</div>
                        <div className="md-popup-contents pt0 pl0">
                            <div>
                                <div className="row pt10 pb10 bt-border-bottom ml0 mr0 bgf8">
                                    <div className="col-md-3 col-xs-12 text-center pt8">
                                        <small><b>결합상품 선택</b></small>
                                    </div>
                                    <div className="col-md-9 col-xs-12">
                                        <a onClick={()=>{self.OpenProductPopup()}} className="btn btn-default form-control">{self.product_names[self.state.product_index]}</a>
                                    </div>
                                </div>
                            </div>
                            { (self.state.product_index != 0) ?
                            <div>
                                <div className="row pt10 pb10 bt-border-bottom ml0 mr0">
                                    <div className="col-md-3 col-xs-12 text-center pt8">
                                        <small>유선상품</small>
                                    </div>
                                    <div className="col-md-6 col-xs-12">
                                        <a onClick={()=>{self.OpenLinePopup()}} className="btn btn-default form-control">
                                            {(!self.state.select_line_product) ? '미적용' : self.state.select_line_product.name}
                                        </a>
                                    </div>
                                    <div className="col-md-3 col-xs-12">
                                        {(self.state.line_discount != 0) ? <span className="right font14 pt10 gray">유선할인 <b className="requirefield">{number_input_format(self.state.line_discount)}원</b></span> : <span className="right font14 pt10 gray"><b>할인 미적용</b></span>}
                                    </div>
                                </div>
                            </div>
                                : '' }
                            {
                                (self.state.select_line_product) ?
                                <div className="row pt10 pb10 bt-border-bottom ml0 mr0">
                                    <div className="col-xs-8 text-left pt8 pb8">
                                        <div className="pb10 border-dashed-bottom-1">
                                            <small><b>무선상품</b></small>
                                            <span className="right color"><small>(무선할인)</small></span>
                                        </div>

                                        <div className="pt8">
                                            <table className="table">
                                                <tbody>
                                                    {self.state.lines.map((line,index)=>{
                                                        if( self.maxIndex < index) {
                                                            return null;
                                                        } else {
                                                            let readOnly = "";
                                                            if(index == 0) {
                                                                readOnly = "readOnly";
                                                            }
                                                            return (
                                                                <tr key={index} className="font14">
                                                                    <td className="width120 vamiddle">
                                                                        <b>{line.name}</b>
                                                                    </td>
                                                                    <td>
                                                                        <a onClick={()=>{self.pricePopupOpen(index)}} readOnly={readOnly}
                                                                        className="form-control btn btn-default font18 text-center">{(line.obj) ? line.obj.name : '미적용'}</a>
                                                                    </td>
                                                                    <td className="width120 text-right font16 pt14">
                                                                        <b>{number_input_format(line.discount)}</b> 원
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 pt8">
                                        <div className="border-dashed-bottom-1 pb10">
                                            <small><b>결합옵션</b></small>
                                        </div>
                                        <div className="pt8">
                                            {(this.state.product_index == 4) ?
                                            <div>
                                                <div className="font14">무선가입년수합산<small className="gray">(가입년수선택)</small></div>
                                                <div className="pt10">
                                                    <select onChange={self.onYearChanged.bind(this)} className="form-control">
                                                        <option value="0">가입년수 10년 미만</option>
                                                        <option value="1">가입년수 20년 미만</option>
                                                        <option value="2">가입년수 30년 미만</option>
                                                        <option value="3">가입년수 30년 이상</option>
                                                    </select>
                                                </div>
                                            </div>
                                            : ''
                                            }
                                            {(this.state.product_index == 1) ?
                                                <div>
                                                    <div className="font14">회선지정</div>
                                                    <div className="pt10">
                                                        <select onChange={self.onFocusLineChanged.bind(this)} className="form-control">
                                                            <option key={-1} value="-1">미지정</option>
                                                            {
                                                                 this.state.lines.map((line, index)=>{
                                                                    return ( line.obj != null ) ? <option key={index} value={index}>{line.name}</option> : null
                                                                 })
                                                            }
                                                        </select>
                                                    </div>
                                                </div> : ''}
                                        </div>
                                    </div>
                                </div>:''
                            }
                            {(self.state.select_line_product) ?
                            <div className="row text-center pt15">
                                <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-md btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                                <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-md btn-select2">취소</a>
                            </div>
                            : ''}
                        </div>
                    </div>
                </div>
                <TogetherProductpopup onProductChanged={(index)=>{self.onProductChanged(index);}} ref={(ref)=>{this._togegherProductPopup=ref}}/>
                <Togetherlinepopup onLineChanged={(product)=>{self.onLineChanged(product)}} ref={(ref)=>{this._togetherlinePopup=ref}}/>
                <Pricepopup onPriceChanged={(price)=>{
                    self.onPriceChanged(price)}
                } ref={(ref)=>{this._pricePopup=ref}}/>
            </Modal>
        )
    }
}
